import * as Actions from '../actions';

const initialState = {
    rombel_ringkas: {
        rows: [{
            kode_wilayah: '---',
            nama: '---'
        }],
        total: 0
    },
    rls: {
        datasets: [],
        labels: ['progres...']
    }
};


const RekapRobel = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.GET_RINGKAS_ROMBEL:
        {
            return {
                ...state,
                rombel_ringkas: action.payload
            };
        }
        case Actions.GET_REKAP_LAMA_SEKOLAH:
        {
            return {
                ...state,
                rls: action.payload
            };
        }
        default:
        {
            return state;
        }
    }
}

export default RekapRobel;